import { useState } from "react";
import { Plus, Trash2, Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { field, Panel, useAdminSettings } from "@/components/admin/shared";

const Item = ({ f, i, upd, remove }) => (
  <li className="space-y-2 rounded-xl border border-line p-4" data-testid={`faq-edit-${i}`}>
    <div className="flex items-center justify-between gap-3">
      <label className="flex items-center gap-2 text-xs font-semibold text-mute">
        <Switch checked={f.published} onCheckedChange={(v) => upd({ published: v })} data-testid={`faq-published-${i}`} /> {f.published ? "Publicada" : "Oculta"}
      </label>
      <button type="button" onClick={remove} aria-label="Eliminar pregunta" className="text-red-500" data-testid={`faq-delete-${i}`}><Trash2 size={16} /></button>
    </div>
    <input aria-label="Pregunta" className={`${field} font-semibold`} value={f.q} onChange={(e) => upd({ q: e.target.value })} data-testid={`faq-q-${i}`} />
    <textarea aria-label="Respuesta" rows={3} className={field} value={f.a} onChange={(e) => upd({ a: e.target.value })} data-testid={`faq-a-${i}`} />
    {f.a.includes("[Completar") && <p className="text-xs font-semibold text-amber-700">Falta completar esta respuesta con los datos reales del taller antes de publicarla.</p>}
  </li>
);

const Editor = ({ settings, save }) => {
  const [faqs, setFaqs] = useState(settings.faqs);
  const upd = (i, p) => setFaqs(faqs.map((f, j) => (j === i ? { ...f, ...p } : f)));
  return (
    <Panel title="Preguntas frecuentes" action={<button className="btn-ghost !py-2" onClick={() => setFaqs([...faqs, { id: `f-${Date.now()}`, q: "Nueva pregunta", a: "", published: false }])} data-testid="faq-add-btn"><Plus size={16} /> Agregar</button>}>
      <p className="mb-4 text-sm text-mute">Estas preguntas aparecen en el asistente del sitio y en la página de inicio. Solo se muestran las publicadas. El asistente también las usa para responder.</p>
      <ul className="space-y-3">{faqs.map((f, i) => <Item key={f.id} f={f} i={i} upd={(p) => upd(i, p)} remove={() => setFaqs(faqs.filter((_, j) => j !== i))} />)}</ul>
      <button className="btn-gold mt-6" onClick={() => save({ faqs })} data-testid="faq-save-btn">Guardar preguntas</button>
    </Panel>
  );
};

export const FaqTab = () => {
  const { settings, save } = useAdminSettings();
  if (!settings) return <Loader2 className="animate-spin text-brand" />;
  return <Editor settings={settings} save={save} />;
};
